import { Sparkles } from "lucide-react";
import { Tile, Stat, Chip } from "./Tile";
import { money, usd } from "../../lib/dash";

export const SalesTile = ({ sales, index }) => (
  <Tile id="sales" index={index} kicker={`Tile 7 · ${sales.label}`} title="Sales">
    <div className="grid grid-cols-3 gap-2">
      <Stat testid="sales-orders" label="Duck orders" value={sales.orders} />
      <Stat testid="sales-ducks" label="Ducks" value={sales.ducks} />
      <Stat testid="sales-revenue" label="Revenue" value={money(sales.revenue, sales.currency)} />
    </div>
    <div className="mt-3 flex items-center gap-3 rounded-xl border border-border px-3 py-2.5">
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-primary/20 text-accent-strong"><Sparkles className="h-4 w-4" /></span>
      <div className="min-w-0">
        <p className="text-[13px] font-semibold">
          <span data-testid="sales-images">{sales.images.count}</span> images generated by customers
        </p>
        <p className="text-[11px] text-muted-foreground">Renders, styles and variations · {usd(sales.images.usd)} ledger cost</p>
      </div>
    </div>
    <p className="mt-3 text-[11px] text-muted-foreground">
      {sales.basis}. Cancelled and test orders are left out.
      {sales.unpriced_lines ? ` ${sales.unpriced_lines} line(s) have no stored price.` : ""}
    </p>
    <div data-testid="sales-not-yet" className="mt-auto flex flex-wrap items-center gap-1.5 pt-3">
      <span className="text-[11px] text-muted-foreground">Not built yet:</span>
      {sales.not_yet.map((x) => <Chip key={x}>{x}</Chip>)}
    </div>
  </Tile>
);
